import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "lznelist_all acea-row row-top"
};
const _hoisted_3 = {
  class: "lznelist_left"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "lznelist_item_pic"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "lznelist_item_kuang acea-row row-top"
};
const _hoisted_8 = {
  class: "lznelist_item_title acea-row row-top"
};
const _hoisted_9 = {
  class: "lznelist_item_miaoshu acea-row row-top"
};
const _hoisted_10 = {
  class: "lznelist_right acea-row row-between-wrapper"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "shop_pic acea-row row-center-wrapper"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "shop_name acea-row row-center-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "news_postion"
  }, "当前位置： 主页 > 资讯列表", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.catenews_list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "lznelist_item acea-row row-top",
      onClick: $event => $options.goxinwen(item.id, 4)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      src: item.image_input
    }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.synopsis), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "lznelist_item_btn acea-row row-right"
    }, [_createElementVNode("div", {
      class: "lznelist_item_seemore"
    }, "查看详情")], -1))])], 8, _hoisted_4);
  }), 256))]), _createElementVNode("div", _hoisted_10, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "shop_title"
  }, "热门文章", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news_list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "shop_list martopershi",
      onClick: $event => $options.goxinwen(item.id, 4)
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
      src: item.image_input
    }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, _toDisplayString(item.short_title), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "shop_btn acea-row row-center-wrapper"
    }, [_createElementVNode("div", {
      class: "shop_chakan acea-row row-center-wrapper"
    }, " 立即查看 ")], -1))], 8, _hoisted_11);
  }), 256))])]), _createVNode(_component_zrcfooter)]);
}